import * as React from "react";

import { EmptyState } from "./EmptyState";

export const NoSearchResults: React.FC<{ searchTerm: string }> = ({
  searchTerm,
}) => {
  return (
    <EmptyState>
      <div className="header-h5">No results found</div>
      <div className="text-sm"> for &quot;{searchTerm}&quot;</div>
    </EmptyState>
  );
};
